// Traditional Indian mehndi-inspired SVG ornaments

export const Medallion = ({ className = "", size = 48 }) => {
  const petals = Array.from({ length: 12 });
  const dots = Array.from({ length: 24 });
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      fill="none"
      aria-hidden="true"
    >
      <circle cx="50" cy="50" r="5" fill="currentColor" />
      <circle cx="50" cy="50" r="13" stroke="currentColor" strokeWidth="1.4" />
      {petals.map((_, i) => (
        <ellipse
          key={i}
          cx="50"
          cy="24"
          rx="3.6"
          ry="9"
          fill="currentColor"
          transform={`rotate(${i * 30} 50 50)`}
        />
      ))}
      <circle
        cx="50"
        cy="50"
        r="33"
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray="1.5 4"
      />
      {dots.map((_, i) => (
        <circle
          key={i}
          cx="50"
          cy="12"
          r="1.5"
          fill="currentColor"
          transform={`rotate(${i * 15} 50 50)`}
        />
      ))}
    </svg>
  );
};

export const Paisley = ({ className = "", size = 32 }) => (
  <svg
    width={size}
    height={size * 1.03}
    viewBox="0 0 60 62"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M30.5,2 C14,2 2,15 2,32 c0,14 10,26 24,28 C15,55 8,45 8,34 C8,22 18,12 30,12 c8,0 14,6 14,13 c0,6 -4,10 -9,10 c-4,0 -7,-3 -7,-7 c0,-3 2,-5 5,-5 c1,0 2,0 3,1 C40,20 33,19 33,26 c0,5 4,9 10,9 c8,0 14,-7 14,-16 C57,10 45,2 30.5,2 Z" />
  </svg>
);

// Decorative section divider with center medallion + flanking paisleys
export const OrnateDivider = ({ className = "", tone = "text-henna" }) => (
  <div
    className={`flex items-center justify-center gap-3 ${tone} ${className}`}
    aria-hidden="true"
  >
    <span className="h-px w-12 bg-current opacity-30 sm:w-24" />
    <Paisley className="rotate-90 opacity-60" size={22} />
    <Medallion size={38} className="opacity-90" />
    <Paisley className="-rotate-90 opacity-60" size={22} />
    <span className="h-px w-12 bg-current opacity-30 sm:w-24" />
  </div>
);

// Large faint mandala for background layering
export const MandalaWatermark = ({ className = "", size = 520 }) => {
  const rings = Array.from({ length: 24 });
  const petals = Array.from({ length: 16 });
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={className}
      fill="none"
      aria-hidden="true"
    >
      <circle cx="100" cy="100" r="10" stroke="currentColor" strokeWidth="1" />
      <circle cx="100" cy="100" r="30" stroke="currentColor" strokeWidth="0.8" />
      <circle cx="100" cy="100" r="55" stroke="currentColor" strokeWidth="0.8" strokeDasharray="2 5" />
      <circle cx="100" cy="100" r="80" stroke="currentColor" strokeWidth="0.8" />
      <circle cx="100" cy="100" r="96" stroke="currentColor" strokeWidth="0.6" strokeDasharray="1 6" />
      {petals.map((_, i) => (
        <ellipse
          key={`p${i}`}
          cx="100"
          cy="55"
          rx="7"
          ry="22"
          stroke="currentColor"
          strokeWidth="0.8"
          transform={`rotate(${i * 22.5} 100 100)`}
        />
      ))}
      {rings.map((_, i) => (
        <circle
          key={`d${i}`}
          cx="100"
          cy="20"
          r="2"
          fill="currentColor"
          transform={`rotate(${i * 15} 100 100)`}
        />
      ))}
    </svg>
  );
};

// Small corner flourish (quarter arrangement of paisleys)
export const CornerFlourish = ({ className = "" }) => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4,116 C4,66 30,20 116,4"
      stroke="currentColor"
      strokeWidth="1"
      strokeDasharray="2 5"
    />
    <path
      d="M14,116 C14,72 40,30 116,14"
      stroke="currentColor"
      strokeWidth="1"
    />
    <circle cx="8" cy="112" r="3" fill="currentColor" />
    <circle cx="112" cy="8" r="3" fill="currentColor" />
  </svg>
);
